<template>
    <!-- 专家问诊列表 -->
    <div class="page-container physician-inquiry-container">
        <!-- 搜索 -->
        <!-- <div class="search-container" @click="onClickSearch">
            <div class="search">
                <i class="icon"></i>
                <span class="txt">搜索医院、医生、科室、疾病</span>
            </div>
        </div> -->
        <!-- 选择 -->
        <div class="choice-container">
            <ul class="condition-container">
                <li class="item" @click="choiceDepartment">{{curDepartmentName}}<i class="icon-arrow" :class="[rotateDepartment?'icon-arrow-up':'icon-arrow-down']"></i></li><span class="line"><i class="l"></i></span>
                <li class="item" @click="choiceRank">{{curRankName}}<i class="icon-arrow" :class="[rotateRank?'icon-arrow-up':'icon-arrow-down']"></i></li><span class="line"><i class="l"></i></span>
				<li class="item" @click="choiceDoctorTitle">{{curDoctorTitle}}<i class="icon-arrow" :class="[rotateDoctorTitle?'icon-arrow-up':'icon-arrow-down']"></i></li>
            </ul>
            <!-- 排序 -->
            <div class="tag-container" v-show="showRank">
                <ul class="tag-list doctor-title">
                    <li class="tag-list-item" :class="{'current':index == rankIndex}" v-for="(item,index) in rankData" :key="item.type" @click="choiceRankTag(item)">{{item.name}}
						<i :class="{'icon':index == rankIndex}"></i></li>
                </ul>
            </div>

			<!-- 职称 -->
            <div class="tag-container" v-show="showDoctorTitle">
                <ul class="tag-list doctor-title">
                    <li class="tag-list-item" :class="{'current':index == doctorTitleIndex}" v-for="(item,index) in doctorTitleData" :key="item.type" @click="choiceDoctorTitleTag(item)">{{item.name}}
						<i :class="{'icon':index == doctorTitleIndex}"></i></li>
                </ul>
            </div>
        </div>
        <div v-show="showDoctorTitle || showRank" class="mask" @touchmove.prevent @click="closeChoice"></div>

        <div class="list-container">
            <!-- 疾病 -->
            <div class="tag-container-1" v-show="showDiseaseTag">
                <ul class="tag-list" v-if="diseaseData.length > 0">
                    <li class="tag-list-item" :class="{'current':item.show}" v-for="(item,index) in diseaseData" :key="item.diseaseId" @click="choiceDiseaseTag(index,item)">{{item.diseaseName}}</li>
                </ul>
            </div>
            <!-- 列表 -->
            <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10">
                <div class="physician-inquiry-list">
                    <div class="item" v-for="(item,index) in doctorListData" :key="index" @click="toDoctorHomePage(item)">
                        <div class="item-left">
                            <span class="portrait">
                                <img :src="item.doctorPhoto" alt=""/>
                            </span>
                        </div>
                        <div class="item-middle">
                            <p class="doctor-container">
                                <span class="doctor-name">{{item.doctorName}}</span>
                                <span>{{item.doctorTechnicalTitle}}</span>
                            </p>
                            <p class="hospital-container">
                                <span class="mr-5">{{item.curHospitalName}}</span>
                                <span>{{item.curDepartment}}</span>
                            </p>
                            <p class="consult-container">
                                <span>问诊量</span>
                                <span class="num">{{item.totalConsultCount || '暂无'}}</span>
                                <span class="mr-5 score">评分</span>
                                <span class="num">{{item.commentScore || '暂无'}}</span>
                            </p>
                            <p class="good-container">
                                <span class="ellipsis">擅长：{{item.feature || '暂无'}}</span>
                            </p>
                            <p class="price-container">
                                <span class="price">¥{{item.lowestFee/100 || 0}}起</span>
								<span class="txt">可咨询</span>
                            </p>
							<p class="tag" v-if="item.honoraryTitle">
								<span>{{item.honoraryTitle}}</span>
							</p>
                        </div>
                    </div>
                </div>
                <div class="loading" v-if="isLoading">正在加载中...</div>
                <div class="no-more" v-if="noMore">没有更多了~</div>
            </div>
        </div>

        <template v-if="isError">
            <page-error :title="error" :height="height"></page-error>
        </template>

        <!-- 筛选科室 -->
        <wand-cascade
        v-model="showDepartment"
        :data="departmentListData"
        :auto-select="true"
        :default-select="selectedDepartment"
        @change="handleChangeDepartment"
        @cancel="cancelDepartment"
        title="选择科室"
        confirm-txt="完成">
		<div slot="item" slot-scope="scope">
			{{scope.item.text}}
			<!-- 从医院进来才显示-->
			<span class="tag" v-if="scope.item.slef.deptSpecialty == 1 && hospitalUuid">
				国家重点
			</span>
			<span class="tag" v-else-if="scope.item.slef.deptSpecialty == 2 && hospitalUuid">
				重点专科
			</span>
		</div>
        </wand-cascade>
    </div>
</template>

<script>
import { WandCascade } from '@weiyi/wand-ui'
import { DoctorList, DoctorTitleList, DepartmentList, DepartmentListFromHospital, DepDiseaseList, RankList } from '@/api/doctor.js'

export default {
    components: {
        WandCascade
    },
    data () {
        return {
            isLoadMore: true,
            height:'',
            isError: false,
            error:'抱歉，暂未找到符合条件的医生',
            busy:false,
            isLoading:false,     	// 加载中
            noMore:false,       	// 是否有更多
            userAgent:'',
            rotateDepartment: false,
			rotateDoctorTitle: false,
			rotateRank: false,
            doctorListData: [],     // 医生列表
            diseaseData: [], 		// 疾病列表
            diseaseName: '',        // 疾病名称
            showDepartment: false,  // 科室
            showDiseaseTag: true,   // 显示疾病tag
			showDoctorTitle: false, // 医生职称
			showRank: false,  		// 排序
            doctorTitleData: DoctorTitleList, // 医生职称列表
			doctorTitleIndex:'',
			rankData: RankList,
			rankIndex:'',
			rankValue: '',					// 选中排序
            departmentListData: [],
			departmentId:'',        		// 选中科室ID
			selectedDepartment: ['',''],	// 选择科室
            level:'',               		// 科室层级
            curDepartmentName:'全部科室',   // 选中科室
			curDoctorTitle:'医生职称',      // 选中医生职称
			curRankName:'综合排序',      	// 选中排序
            doctorTitleName:'医生职称',
            pageSize:10,            		// 每页条数
            pageNumber:1,           		// 当前页数
            total:1,                		// 总条数
			totalPage:1,             		// 总分页数
			hospitalUuid: '',				// 医院Uuid
			areaId: '',						// 区域id
			toHospitalName: '',
			toHospitalDomainName: '',
			tcmAreaDiseaseId: '',			// 区域疾病id
			imageTextServiceCode: '', // 图文问诊service_code
			phoneServiceCode: '',	// 电话问诊service_code
			mulitDepartmentId: '' // 不限科室id
        }
    },
    created () {
        this.userAgent = this.$getUserAgent
    },

    mounted () {
		const areaInfo = JSON.parse(sessionStorage.getItem('AreaInfo'))
		this.tcmAreaDiseaseId = this.$route.query.tcmAreaDiseaseId ? this.$route.query.tcmAreaDiseaseId : ''
		this.hospitalUuid = this.$route.query.hospitalUuid ? this.$route.query.hospitalUuid : ''
		this.departmentId = this.$route.query.stdDeptId ? this.$route.query.stdDeptId : ''
		this.areaId = areaInfo.areaId
		this.toHospitalName = areaInfo.toHospitalName
		this.toHospitalDomainName = areaInfo.toHospitalDomainName
		this.imageTextServiceCode = areaInfo.imageTextServiceCode
		this.phoneServiceCode = areaInfo.phoneServiceCode

		// 针对医生主页返回医生列表的情况
		if (sessionStorage.getItem('stdDeptId')) {
			this.departmentId = JSON.parse(sessionStorage.getItem('stdDeptId')).stdDeptId
			this.tcmAreaDiseaseId = ''
		}

		// 科室列表
        this.getDepartmentData()
		this.share()
		// 不限
		if (this.departmentId.split(',').length > 1) {
			this.mulitDepartmentId = this.departmentId.split(',')[0]
		} else {
			this.getDieaseList(this.departmentId)
		}

        for(let item of this.diseaseData){
            item.show = false
		}
	},

	destroyed () {
		// 清除科室
		sessionStorage.removeItem('stdDeptId')
	},

    methods: {
        // 微信分享
        share() {
            if(this.userAgent === 'weixin') {
                // 分享
                this.$weixinShare({
                    title: this.toHospitalName + '·中医专家问诊',
                    desc: '中医专家 在线开药',
                    imgUrl: window.location.origin + '/share.jpg'
                })
            }
        },

        // 加载中
        showLoading () {
            this.$wand.loading.show({disableClick: false})
        },

        // 加载完成
        hideLoading () {
            this.$wand.loading.hide()
        },

        // 获取医生列表数据
        getDoctorList (type) {
            let params = {}
            let doctorTitle = this.doctorTitleIndex === 0 ?'':this.doctorTitleIndex

            if(this.doctorTitleIndex === 4) {
                doctorTitle = 99
            }

            if(this.doctorTitleIndex === 2) {
                doctorTitle = 3
            }

            if(this.doctorTitleIndex === 3) {
                doctorTitle = 2
			}

			params = {
				stdDeptId: this.departmentId,
				pageNumber: this.pageNumber,
				pageSize: this.pageSize,
				doctorTitle: doctorTitle,
				diseaseName: this.diseaseName,
				hospital: this.hospitalUuid,
				areaId: this.areaId,
				level:this.level,
				sort: this.rankValue,
				tcmAreaDiseaseId: this.tcmAreaDiseaseId // 区域疾病id
			}

			//价格升序 降序
			if (this.rankIndex === 4) {
				params.sortOrder = 'asc'
			} else if (this.rankIndex === 5) {
				params.sortOrder = 'desc'
			}

            this.noMore = false
            // 第一次加载中
            if(this.pageNumber === 1){
                this.showLoading()
            } else {
                // 无限滚动加载中
                this.isLoading = true
            }
			this.isError = false

            DoctorList(params).then(async res => {
                let listDatas = res.results

                this.isLoadMore = true

                // 分页
                this.total = res.totalCount
                this.totalPage = res.totalPages

                // 第一次加载完成
                if(this.pageNumber === 1){
                    this.hideLoading()
                }

                if(listDatas.length > 0){

                    this.busy = false
                    // 多次加载数据
                    if(type === 'loadMore'){
                        for(let i = 0;i<listDatas.length;i++){
                            this.doctorListData.push(listDatas[i])
                        }
                        this.pageNumber++
                    } else {
                        // 第一次加载
                        this.doctorListData = listDatas
                    }

                    // 当前分页数超过总分页数
                    if (this.pageNumber > this.totalPage) {
                        this.noMore = true          // 显示没有更多
                        this.isLoading = false      // 关闭加载中
                    }

                }else {
                    this.isLoading = false
                    this.doctorListData = listDatas
                    this.isError = true
                }

			}).catch(err => {
                this.isError = true
                this.error = '服务器错误，请重试'
                this.hideLoading()
                window.scrollTo(0,0)
				console.log('err: ', err)
			})
		},

        // 加载更多
        loadMore(){
            this.busy = true
            if(!this.isLoadMore){
                return false
			}
            if(this.pageNumber !== 1) {
                this.isLoading= true
            }

            // 当前分页数超过总分页数
            if (this.pageNumber > this.totalPage) {
                this.busy = false
                this.noMore = true          // 不显示没有更多
                this.isLoading = false      // 关闭加载中
                return false
            }
            setTimeout( () => {
                this.getDoctorList('loadMore')

            },500)
        },

        // 选择科室
        choiceDepartment () {
            if(this.showDoctorTitle) {
                return false
            }
            this.rotateDepartment = !this.rotateDepartment // 箭头
            this.showDepartment = !this.showDepartment
        },

        // 选择科室数据
        handleChangeDepartment (data) {
			let stdDeptId = data[1].value
            if(data[data.length-1].name === '全部') {
                this.level = 1
                this.departmentId = data[0].value
                this.curDepartmentName = data[0].name
            } else {
                this.curDepartmentName = data[data.length-1].name
                this.departmentId = data[data.length-1].value
                this.level = 2
			}

			// 医生主页返回列表 保存上次选择科室
			sessionStorage.setItem('stdDeptId', JSON.stringify({stdDeptId:this.departmentId}))

			this.rotateDepartment = false
			this.tcmAreaDiseaseId = '' // 清空区域疾病id
			this.diseaseName = '' // 清空疾病名
			this.emptyCondition()
			// 获取科室对应疾病列表
			this.getDieaseList(stdDeptId)
        },

        // 获取科室数据
        getDepartmentData () {
			let getData = ''

			let params = {
				hospitalUuid: this.hospitalUuid,
				areaId: this.areaId
			}
			// 判断是否从医院过来
			if (this.hospitalUuid) {
				getData = DepartmentListFromHospital
			} else {
				getData = DepartmentList
			}

            getData(params).then(async res => {
				let data = []
				let curDepartmentId = this.departmentId // 当前科室id

                for(let item of res){
                    let subData = []
					let stdDeptId = item.stdDeptId
                    for(let subItem of item.stdDeptList) {
                        subData.push({
                            text:subItem.stdDeptName,
							value:subItem.stdDeptId,
							deptSpecialty: subItem.deptSpecialty // 特色科室 1国家重点2重点
						})
						// 选择科室id
						if (curDepartmentId === subItem.stdDeptId) {
							this.selectedDepartment = [item.stdDeptId, subItem.stdDeptId]
							this.curDepartmentName = subItem.stdDeptName
							console.log(this.curDepartmentName)
						}
						// 不限，需要找到一级科室id
						if (this.mulitDepartmentId === subItem.stdDeptId) {
							this.selectedDepartment = [item.stdDeptId, subItem.stdDeptId]
							this.curDepartmentName = item.stdDeptName
						}
                    }
                    subData.unshift({
                        text:'全部',
						value:stdDeptId,
						deptSpecialty:''
                    })
                    data.push({
                        text:item.stdDeptName,
						value:item.stdDeptId,
						deptSpecialty:item.deptSpecialty,
                        children:subData
                    })
                }
				this.departmentListData = data
			}).catch(err => {
				console.log('err: ', err)
			})
        },

        // 关闭选择科室
        cancelDepartment (){
            this.rotateDepartment = false
		},

		// 获取科室对应疾病列表
		getDieaseList (stdDeptId) {
			let params = {
				tcmDeptId: stdDeptId //科室id
			}
			DepDiseaseList(params).then(async res => {
				this.diseaseData = res
			}).catch(err => {
                this.isError = true
                this.error = '服务器错误，请重试'
                this.hideLoading()
                window.scrollTo(0,0)
				console.log('err: ', err)
			})
		},

		// 选择疾病
        choiceDiseaseTag (index,data) {
			this.noMore = false

            this.diseaseData.forEach(element => {
                if (data == element) {
                    element.show = !element.show

                    if(element.show === true) {
                        this.diseaseName = data.diseaseName
                    } else {
                        this.diseaseName = ''
                    }
                } else {
                    element.show = false
                }
            });

            this.emptyCondition()
		},

		// 选择排序
        choiceRankTag (data) {
            this.rankIndex = data.type
			this.rankName = data.name
			this.rankValue = data.value

			this.showDiseaseTag = true // 显示疾病
			this.showRank = false // 隐藏排序
            this.showDoctorTitle = false // 隐藏职称
            this.rotateRank = false
            this.curRankName = (this.rankName === '综合排序' || this.rankName === '') ? '综合排序':this.rankName
            this.emptyCondition()
        },

        // 选择职称
        choiceDoctorTitleTag (data) {
            this.doctorTitleIndex = data.type
			this.doctorTitleName = data.name

			this.showDiseaseTag = true // 显示疾病
			this.showRank = false // 隐藏排序
			this.showDoctorTitle = false // 隐藏职称
            this.rotateDoctorTitle = false
            this.curDoctorTitle = (this.doctorTitleName === '全部' || this.doctorTitleName === '') ?'医生职称':this.doctorTitleName
            this.emptyCondition()
        },

        // 筛选医生职称
        choiceDoctorTitle () {
			this.showRank = false // 隐藏排序
            this.showDoctorTitle = !this.showDoctorTitle // 显示职称
            this.rotateDoctorTitle = !this.rotateDoctorTitle // 箭头
		},

		// 筛选排序
        choiceRank () {
			this.showDoctorTitle = false // 隐藏职称
			this.showRank = !this.showRank // 显示排序
            this.rotateRank = !this.rotateRank // 箭头
        },

        // 清空
        emptyCondition () {
            this.pageNumber = 1
            window.scrollTo(0,0)
			this.doctorListData = []
            this.isLoadMore = false
			this.getDoctorList('loadMore')
		},

		// 关闭筛选
		closeChoice () {
			this.showRank = false
			this.showDoctorTitle = false
			this.rotateRank = false
			this.rotateDoctorTitle = false
		},

        // 点击搜索跳转到门户
        onClickSearch () {
			const isTest = window.location.href.indexOf('guahao-test') > -1 ? true : false
			// 测试环境
			if (isTest) {
				window.location.href = 'http://' + this.toHospitalDomainName + '/consult/more?qarea='+ this.areaId +
			'&qcity='+ this.areaName
			} else {
				// 线上
				window.location.href ='https://' + this.toHospitalDomainName + '/consult/more?qarea='+ this.areaId +
				'&qcity='+ this.areaName
			}

        },

        // 跳转到医生主页
        toDoctorHomePage (item) {
			const isTest = window.location.href.indexOf('guahao-test') > -1 ? true : false
			// 测试环境
			if (isTest) {
				window.location.href ='http://' + this.toHospitalDomainName + '/expert/consult/' + item.doctorUuid
				+ '?from=community&imageSC=' + this.imageTextServiceCode
			} else {
				// 线上
				window.location.href ='https://' + this.toHospitalDomainName + '/expert/consult/' + item.doctorUuid
				+ '?from=community&imageSC=' + this.imageTextServiceCode + '&phoneSC=' + this.phoneServiceCode
			}
        }
  }
}
</script>

<style lang="less" scoped>
    @import '~@/assets/style/page/physician-inquiry.less';
</style>
